'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "SectionGroup": "Polaris-Listbox-Section__SectionGroup",
  "noDivider": "Polaris-Listbox-Section--noDivider"
};

exports.default = styles;
